export const MAP_URL = {
  login: 'admin/login',
  adminUsers: 'admin/adminUsers',
  user: 'admin/user',
  productCategory: 'admin/productCategory',
  product: 'admin/product',
  branch: 'admin/branch',
  need: 'admin/need',
  needCategory: 'admin/needCategory',
  unit: 'admin/unit',
  loadingRequest: 'admin/loadingRequest',
  unitProcessor: 'admin/unitProcessor',
  status: 'admin/status',
  statusLoading: 'admin/statusLoading',
  needNotes: 'admin/needNote',
  report: 'admin/report',
  reportProduction: 'admin/reportProduction',
  reportInputProduct: 'admin/reportInputProduct',
  reportstat: 'admin/reportstat',
  whatsapp: 'admin/whatsapp',
  customer: 'admin/customer',
  contact: 'admin/contact',
  hits : 'admin/hits',
  alarms : 'admin/alarms',
  preferCall : 'admin/preferCall',
  statusCall: 'admin/statusCall',
  package: 'admin/package',
  orderType: 'admin/orderType',
  customerCategory: 'admin/customerCategory',
  contactCategory: 'admin/contactCategory',
  customerPriority: 'admin/customerPriority',
  customerRating: 'admin/customerRating',
  storage: 'admin/storage',
  clue: 'admin/clue',
  reminder: 'admin/reminder',
  sendSMS: 'admin/sendSMS',
  transaction: 'admin/transaction',

  notifications: 'admin/notifications',
  productUnit: 'admin/productUnit',
  baseUnit: 'admin/baseUnit',
  rawMaterial: 'admin/rawMaterial',
  productCapacity: 'admin/productCapacity',
  eventPanel: 'admin/eventPanel',

  // profile: 'admin/profile',




}
